import { ref } from 'vue'
import { defineStore } from 'pinia'
import { useConfigStore } from '@/stores/config'
import { useRequestsStore } from '@/stores/requests'
import { useTokenStore } from '@/stores/token'

export const useAreasStore = defineStore('areas', () => {
    const configStore       = useConfigStore()
    const requestsStore     = useRequestsStore()
    const tokenStore        = useTokenStore()

    const areas              = ref({})
    const areasProcess       = ref(false)
    const areasMsg           = ref({})

    const areaProcess       = ref(false)
    const areaMsg           = ref({})

    const areaCreateProcess = ref(false)
    const areaCreateMsg     = ref({})

    const areaUpdateProcess = ref(false)
    const areaUpdateMsg     = ref({})

    const areaDeleteProcess = ref(false)
    const areaDeleteMsg     = ref({})

    async function createArea(payload) {
        // console.log(payload)

        areaCreateProcess.value = true
        const token = tokenStore.access
        let result = {}

        if(token) { 
            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/areas`, 
                method: 'POST', 
                token,
                data: payload
            })

            if(!request.error) {
                result = request
                areaCreateMsg.value = { success: true }
            } else {
                areaCreateMsg.value = { success: false, text: request.error }
            }

        } else {
            areaCreateMsg.value = { success: false, text: 'EUnauthRequest' }
        }

        areaCreateProcess.value = false
        return result
    }

    async function readAreas(payload, isUseStore) {
        areasProcess.value = true
        const token = tokenStore.access
        let result = {}

        if(token) { 
            let params = ''

            if(payload) {
                for( let param in payload) {

                    if(Array.isArray(payload[param])) {
                        payload[param].map( el => {

                            params.length ?
                                params += '&' + param + '=' + el :
                                params = '?' + param + '=' + el
                        })
                    } else {
                        params.length ?
                            params += '&' + param + '=' + payload[param] :
                            params = '?' + param + '=' + payload[param]
                    }
                }
            }

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/areas${params}`, 
                method: 'GET', 
                token
            })

            if(!request.error) {
                result = request

                if (isUseStore) areas.value = request

                areasMsg.value = { success: true }
            } else {
                if (isUseStore) areas.value = {}
                areasMsg.value = { success: false, text: request.error }
            }

        } else {
            areasMsg.value = { success: false, text: 'EUnauthRequest' }
        }

        areasProcess.value = false
        return result
    }

    /**
     * Получение геозоны по UUID
     *
     * @param {String} payload - UUID геозоны
     */
    async function readAreaByUuid(payload) {
        areaProcess.value = true
        
        const token = tokenStore.access
        let result = {}

        if(token) {
            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/areas/${payload}`, 
                method: 'GET', 
                token
            })

            if(!request.error) {
                result = request

                areaMsg.value = { success: true }
            } else {
                areaMsg.value = { success: false, text: request.error }
            }

        } else {
            areaMsg.value = { success: false, text: 'EUnauthRequest' }
        }

        areaProcess.value = false
        return result
    }

    async function updateArea(payload) {
        areaUpdateProcess.value = true
        const token = tokenStore.access

        if(token) {
            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/areas`, 
                method: 'PUT', 
                token,
                data: payload
            })

            if(!request.error) {
                areaUpdateMsg.value = { success: true, text: 'AREA_UPDATE_SUCCESS' }
            } else {
                areaUpdateMsg.value = { success: false, text: request.error }
            }

        } else {
            areaUpdateMsg.value = { success: false, text: 'EUnauthRequest' }
        }

        areaUpdateProcess.value = false
    }
    
    /**
     * Удаление геозоны
     *
     * @param {String} payload - UUID удаляемой зоны
     */
    async function deleteArea(payload) {
        areaDeleteProcess.value = true
        const token = tokenStore.access

        if(token) {
            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/areas/${payload}`, 
                method: 'DELETE', 
                token
            })

            if(!request.error) {
                areaDeleteMsg.value = { success: true, text: 'AREA_DELETE_SUCCESS' }
            } else {
                areaDeleteMsg.value = { success: false, text: request.error }
            }

        } else {
            areaDeleteMsg.value = { success: false, text: 'EUnauthRequest' }
        }

        areaDeleteProcess.value = false
    }

    const setAreaCreateMsg = data => areaCreateMsg.value = data
    const setAreaUpdateMsg = data => areaUpdateMsg.value = data
    const setAreaDeleteMsg = data => areaDeleteMsg.value = data
    const setAreasMsg = data => areasMsg.value = data
    const setAreaMsg = data => areaMsg.value = data

    return {
        areas,
        areasProcess,
        areasMsg,
        areaProcess,
        areaMsg,
        areaCreateProcess, 
        areaCreateMsg,
        areaUpdateProcess, 
        areaUpdateMsg,
        areaDeleteProcess, 
        areaDeleteMsg,
        createArea,
        readAreas,
        readAreaByUuid,
        updateArea,
        deleteArea,
        setAreaCreateMsg,
        setAreaUpdateMsg,
        setAreaDeleteMsg,
        setAreasMsg,
        setAreaMsg
    }
})
